export default (betKey) => {
  const splitKey = betKey.split(':')
  switch (true) {
    case splitKey.length === 2:
      return splitKey[1]

    case splitKey.length === 3 && splitKey[1].length === 3:
      return splitKey[2]

    case splitKey.length === 3 && splitKey[1].length === 6:
      return `${splitKey[1]}:${splitKey[2]}`

    case splitKey.length === 4:
      return `${splitKey[2]}:${splitKey[3]}`
  }
}
